import FetchBase from '../Api/FetchBase'
import { observable, action } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'

export default class HomeBudgetStore extends FetchBase {
  @observable ordering = undefined
  @observable orderingBy = undefined
  @observable projectBudgetLineItemOrderBy = undefined
  @observable projectBudgetLineItemOrdering = undefined

  @observable LineItemSearchText = ''
  @observable lineItemsFilters = {}
  @observable LineItemList = []
  @observable totalListItem = 0
  @observable pfSelectedDateChoice = undefined
  @observable listItemPageNo = DEFAULT_PAGE_START
  @observable mediaCentricUsersLoader = true
  @observable selectedCustomerId = undefined
  @observable searchTextForUsersList = undefined
  @observable usersFilters = {}

  @observable reportBudgetLoader = false
  @observable reportBudgetLine = []
  @observable reportBudgetLineItem = []
  @observable reportBudgetTotal = 0

  @observable orderBy = undefined

  @observable importUsers = []
  @observable importUsersFailures = []
  @observable importUserFromFileLoader = false
  @observable projectLine = []
  @observable projectLineFilter = []
  @observable reportFilterforOnsite = []
  @observable reportFilterforTags = []

  @observable addActionItemLoader = false

  @action.bound
  setProjectOrdering = (value = undefined) => {
    this.projectBudgetLineItemOrdering = value
  }

  @action.bound
  setProjectOrderingBy = (value = undefined) => {
    this.projectBudgetLineItemOrderBy = value
  }

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  SetListItemPageNo = (value = DEFAULT_PAGE_START) => {
    this.listItemPageNo = value
  }

  @action.bound
  setLineItemFilters = (values = {}) => {
    this.lineItemsFilters = values
  }

  @action.bound
  setLineItemSearchText = (value = '') => {
    this.LineItemSearchText = value
  }

  @action.bound
  setSelectedCustomerId = (id) => {
    this.selectedCustomerId = id
  }
  @action.bound
  setSelectedDateChoice = (value) => {
    this.pfSelectedDateChoice = value
  }

  @action.bound
  generateLineItemFiltersforHome = () => {
    let tempgenerateLineItemFilters = {}

    let keys = Object.keys(this.lineItemsFilters || {})
    for (let filter of keys) {
      if (this.lineItemsFilters[filter] !== undefined) {
        tempgenerateLineItemFilters[filter] = this.lineItemsFilters[filter]
      }
    }
    this.LineItemSearchText &&
      (tempgenerateLineItemFilters['search'] = this.LineItemSearchText)
    this.ordering && (tempgenerateLineItemFilters['ordering'] = this.ordering)
    this.ordering && (tempgenerateLineItemFilters['orderBy'] = this.orderingBy)
    return tempgenerateLineItemFilters
  }

  @action.bound
  generateLineItemFiltersforReport = () => {
    let tempgenerateLineItemFilters = {}

    let keys = Object.keys(this.lineItemsFilters || {})
    for (let filter of keys) {
      if (this.lineItemsFilters[filter] !== undefined) {
        tempgenerateLineItemFilters[filter] = this.lineItemsFilters[filter]
      }
    }
    this.LineItemSearchText &&
      (tempgenerateLineItemFilters['search'] = this.LineItemSearchText)
    this.ordering && (tempgenerateLineItemFilters['ordering'] = this.ordering)
    this.ordering && (tempgenerateLineItemFilters['orderBy'] = this.orderingBy)
    this.projectBudgetLineItemOrdering &&
      (tempgenerateLineItemFilters['projectBudgetLineItemOrdering'] =
        this.projectBudgetLineItemOrdering)
    this.projectBudgetLineItemOrdering &&
      (tempgenerateLineItemFilters['projectBudgetLineItemOrderBy'] =
        this.projectBudgetLineItemOrderBy)
    return tempgenerateLineItemFilters
  }

  @action.bound
  getFilters = () => {
    let tempgetFilters = {}
    if (this.ordering) {
      tempgetFilters['ordering'] = this.ordering
      tempgetFilters['orderBy'] = this.orderingBy
      tempgetFilters['projectBudgetLineItemOrdering'] =
        this.projectBudgetLineItemOrdering
      tempgetFilters['projectBudgetLineItemOrderBy'] =
        this.projectBudgetLineItemOrderBy
    }
    return tempgetFilters
  }

  @action.bound
  getAllLineItemsExport = async ({ exportFileType = 'csv' } = {}) => {
    try {
      let options = this.generateLineItemFiltersforReport()
      options['exportFileType'] = exportFileType
      options['forDashboard'] = false
      let response = await this.post(API_ENDPOINTS.REPORT_BUDGET_EXPORT, {
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  // For Dashboard Widget
  @action.bound
  getReportingBudget = async (signal) => {
    try {
      this.reportBudgetLoader = true
      let filters = this.generateLineItemFiltersforHome()
      filters['forDashboard'] = true
      filters['pageLimit'] = '20'
      let response = await this.post(
        API_ENDPOINTS.HOME_REPORT_DASHBOARD_WIDGET,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.reportBudgetTotal = response?.data?.total || 0
        this.reportBudgetLine = response?.data?.projectLineItems || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      console.log(err, 66)
      return [false, undefined]
    } finally {
      this.reportBudgetLoader = false
    }
  }

  @action.bound
  getReportingBudgetFilter = async () => {
    try {
      this.reportBudgetLoader = true
      let filters = this.generateLineItemFiltersforHome()
      filters['forDashboard'] = true
      //   filters['pageLimit'] = '20'
      let response = await this.post(
        API_ENDPOINTS.HOME_REPORT_DASHBOARD_WIDGET,
        {
          ...filters,
        }
      )
      if (response.status) {
        this.reportBudgetTotal = response?.data?.total || 0
        this.reportBudgetLine = response?.data?.projectLineItems || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      console.log(err, 66)
      return [false, undefined]
    } finally {
      this.reportBudgetLoader = false
    }
  }

  // For Reporting
  @action.bound
  getReportingBudgetforReport = async (signal) => {
    try {
      this.reportBudgetLoader = true
      let filters = this.generateLineItemFiltersforReport()
      filters['forDashboard'] = false
      //   filters['pageLimit'] = '20'
      let response = await this.post(
        API_ENDPOINTS.HOME_REPORT_DASHBOARD_WIDGET,
        {
          ...filters,
        },
        signal
      )
      if (response.status) {
        this.reportBudgetTotal = response?.data?.total || 0
        this.reportBudgetLine = response?.data?.projectLineItems || []
        this.reportFilterforOnsite = response?.data.onSiteLeadDropdownData
        this.reportFilterforTags = response?.data.projectTagDropdownData
        this.reportBudgetLineItem = response?.data?.lineItemDropdownData || []
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      console.log(err, 66)
      return [false, undefined]
    } finally {
      this.reportBudgetLoader = false
    }
  }

  @action.bound
  resetFilterForm = () => {
    this.lineItemsFilters = {}
    this.pfSelectedDateChoice = undefined
  }

  @action.bound
  resetUserFilters = () => {
    this.usersFilters = {}

    this.ordering = undefined
    this.orderBy = undefined
    this.projectBudgetLineItemOrderBy = undefined
    this.projectBudgetLineItemOrdering = undefined
  }

  @action.bound
  resetStore = () => {
    this.LineItemSearchText = ''
    this.lineItemsFilters = {}
    this.LineItemList = []
    this.totalListItem = 0
    this.pfSelectedDateChoice = undefined
    this.listItemPageNo = DEFAULT_PAGE_START
    this.mediaCentricUsersLoader = true
    this.selectedCustomerId = undefined
    this.searchTextForUsersList = undefined
    this.reportBudgetLoader = false
    this.reportBudgetLine = []
    this.reportBudgetLineItem = []

    this.reportBudgetTotal = 0
    this.usersFilters = {}
    this.ordering = undefined
    this.orderBy = undefined
    this.projectBudgetLineItemOrderBy = undefined
    this.projectBudgetLineItemOrdering = undefined
    this.addActionItemLoader = false
    this.projectLine = []
    this.projectLineFilter = []
    this.reportFilterforOnsite = []
    this.reportFilterforTags = []
    this.orderingBy = undefined

    this.importUsers = []
    this.importUsersFailures = []
    this.importUserFromFileLoader = false
  }
}
